//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileSaver from "file-saver";
export default {
  name: "",
  data() {
    return {
      wkt_domain_name: localStorage.getItem("wkt_domain_name"),
      wkt_login_peo: JSON.parse(localStorage.getItem("wkt_login_peo")),
      list_ary: [],
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    this.$http
      .get("/search/common.php", {
        params: {
          form: "stu_up_options",
          id: this.wkt_login_peo.id
        }
      })
      .then(res => {
        this.loading = false;
        this.list_ary = res.data.data;
      });
  },
  components: {},
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/list_my_options.vue